export interface WeeklyVerse {
  text: string;
  reference: string;
}

export const WEEKLY_VERSES: WeeklyVerse[] = [
  {
    text: 'Domnul este Păstorul meu: nu voi duce lipsă de nimic.',
    reference: 'Psalmi 23:1',
  },
  {
    text: 'Nu vă îngrijorați de nimic, ci în orice lucru, prin rugăciune și cerere, aduceți cererile voastre înaintea lui Dumnezeu și mulțumiți-I. Și pacea lui Dumnezeu, care întrece orice pricepere, vă va păzi inimile și gândurile voastre în Hristos Isus.',
    reference: 'Filipeni 4:6-7',
  },
  {
    text: 'Nu te teme, căci Eu sunt cu tine; nu te uita cu groază la jur împrejur, căci Eu sunt Dumnezeul tău; Eu te întăresc, tot Eu îți vin în ajutor, tot Eu te sprijin cu dreapta Mea cea biruitoare.',
    reference: 'Isaia 41:10',
  },
  {
    text: 'Veniți la Mine, toți cei osteniți și împovărați, și Eu vă voi da odihnă.',
    reference: 'Matei 11:28',
  },
  {
    text: 'Încrede-te în Domnul din toată inima ta și nu te sprijini pe înțelegerea ta. Recunoaște-L în toate căile tale, și El îți va netezi cărările.',
    reference: 'Proverbe 3:5-6',
  },
  {
    text: 'Binecuvântat să fie Dumnezeu, Tatăl Domnului nostru Isus Hristos, Tatăl îndurărilor și Dumnezeul oricărei mângâieri, care ne mângâie în toate necazurile noastre!',
    reference: '2 Corinteni 1:3-4',
  },
  {
    text: 'Dumnezeu este refugiul și tăria noastră, un ajutor totdeauna găsit în nevoi.',
    reference: 'Psalmi 46:1',
  },
  {
    text: 'Eu cunosc planurile pe care le am cu privire la voi, zice Domnul, planuri de pace și nu de nenorocire, ca să vă dau un viitor și o nădejde.',
    reference: 'Ieremia 29:11',
  },
  {
    text: 'De altfel, știm că toate lucrurile lucrează împreună spre binele celor ce iubesc pe Dumnezeu.',
    reference: 'Romani 8:28',
  },
  {
    text: 'Domnul este aproape de cei cu inima zdrobită și mântuiește pe cei cu duhul întristat.',
    reference: 'Psalmi 34:18',
  },
  {
    text: 'Purtați-vă unii altora poverile și veți împlini astfel legea lui Hristos.',
    reference: 'Galateni 6:2',
  },
  {
    text: 'Aruncați asupra Lui toate îngrijorările voastre, căci El Însuși are grijă de voi.',
    reference: '1 Petru 5:7',
  },
  {
    text: 'Cercetează-mă, Dumnezeule, și cunoaște-mi inima! Încearcă-mă și cunoaște-mi gândurile! Vezi dacă sunt pe o cale rea și călăuzește-mă pe calea veacurilor!',
    reference: 'Psalmi 139:23-24',
  },
  {
    text: 'Dacă lipsește cuiva din voi înțelepciune, să ceară de la Dumnezeu, care dă tuturor cu mână largă și fără mustrare, și i se va da.',
    reference: 'Iacov 1:5',
  },
  {
    text: 'Îmbrăcați-vă dar, ca niște aleși ai lui Dumnezeu, sfinți și preaiubiți, cu îndurare, bunătate, smerenie, blândețe și îndelungă răbdare.',
    reference: 'Coloseni 3:12',
  },
  {
    text: 'Când vei trece prin apă, voi fi cu tine; și când vei trece prin râuri, ele nu te vor îneca.',
    reference: 'Isaia 43:2',
  },
  {
    text: 'Căci Dumnezeu nu ne-a dat un duh de frică, ci de putere, de dragoste și de chibzuință.',
    reference: '2 Timotei 1:7',
  },
  {
    text: 'El vindecă pe cei cu inima zdrobită și leagă rănile lor.',
    reference: 'Psalmi 147:3',
  },
  {
    text: 'Un prieten iubește în orice împrejurare, și frația este de ajutor în nenorocire.',
    reference: 'Proverbe 17:17',
  },
  {
    text: 'Dumnezeul nădejdii să vă umple de bucurie și pace în credință.',
    reference: 'Romani 15:13',
  },
  {
    text: 'Încredințează-ți Domnului căile tale, încrede-te în El, și El va lucra.',
    reference: 'Psalmi 37:5',
  },
  {
    text: 'Să aveți toată smerenia și blândețea, cu îndelungă răbdare, îngăduindu-vă unii pe alții în dragoste.',
    reference: 'Efeseni 4:2',
  },
  {
    text: 'Mângâiați-vă deci unii pe alții și zidiți-vă unii pe alții.',
    reference: '1 Tesaloniceni 5:11',
  },
  {
    text: 'Îmi ridic ochii spre munți… De unde îmi va veni ajutorul? Ajutorul îmi vine de la Domnul, care a făcut cerul și pământul.',
    reference: 'Psalmi 121:1-2',
  },
  {
    text: 'Pace vă las, pacea Mea vă dau. Nu vă dau cum dă lumea.',
    reference: 'Ioan 14:27',
  },
  {
    text: 'Aruncă-ți povara asupra Domnului, și El te va sprijini.',
    reference: 'Psalmi 55:22',
  },
  {
    text: 'Un răspuns blând potolește mânia, dar o vorbă aspră stârnește mânie.',
    reference: 'Proverbe 15:1',
  },
  {
    text: 'Pe cel cu gândul rămas la Tine, Tu îl vei păzi în pacea perfectă.',
    reference: 'Isaia 26:3',
  },
];
